
<div class="col-md-12 padding-left-0px padding-right-0px" *ngIf="mode=='view'">
  <div class="row margin-left-0px margin-right-0px" *ngIf="fieldx ">
    <div class="col-md-10 padding-left-0px padding-right-0px text-align-left">
      <label class="margin-bottom-1px margin-left-10px font-family">{{fieldx.Title}}</label>
    </div>
  </div>
  <div class="row margin-left-0px margin-right-0px" *ngIf="fieldx && fieldx.Columns">
    <div class="col-md-12 padding-left-0px padding-right-0px" *ngIf="fieldx.Columns.length<=5">
      <div class="row">
        <div class="col-1">
          S.No
        </div>
        <div class="row col-11">
          <div class="col-2" *ngFor="let columnName of fieldx.Columns; let ColIndex = index">
            <label class="margin-bottom-0px font-family">{{columnName.Title}}</label>
          </div>
        </div>
      </div>
      <div class="row margin-left-0px margin-right-0px" *ngFor="let row of fieldx.Rows; let RowIndex = index">
        <div class="col-md-1 padding-left-0px padding-right-0px">
          <label class="margin-bottom-0px font-family">[ {{RowIndex+1}} ]</label>
        </div>
        <div class="row col-11">
          <div class="col-md-2 padding-left-0px padding-right-0px" *ngFor="let c of row.Cells;let CellIndex = index">
            <div class="col-12 padding-left-0px padding-right-0px">
              <label class="margin-bottom-0px font-family" *ngIf="c.ValueType!='Date'">{{c.Value}}</label>
              <label class="margin-bottom-0px font-family" *ngIf="c.ValueType=='Date'">{{c.Value | date:'MMM-dd-yyyy'}}</label>
            </div>
          </div>
        
        </div>
      </div>
      </div>
    
    <div class="col-md-12 padding-left-0px padding-right-0px" *ngIf="fieldx.Columns.length>5">
      <div class="row margin-left-0px margin-right-0px" *ngFor="let row of fieldx.Rows; let RowIndex = index">
        <div class="col-md-1 padding-left-0px padding-right-0px">
          <label class="margin-bottom-0px font-family">[ {{RowIndex+1}} ]</label>
        </div>
        <div class="col-md-11 padding-left-0px padding-right-0px">
          <div *ngFor="let c of row.Cells;let CellIndex = index" class=" row margin-left-0px margin-right-0px font-family">
            <div class="col-md-6 padding-left-0px padding-right-0px">
              <label class="margin-bottom-0px font-family" *ngIf="fieldx.Columns[CellIndex]">{{fieldx.Columns[CellIndex].Title}}</label>
            </div>
            <!--getCellTitle(CellIndex)-->

            <div class="col-md-6 padding-left-0px padding-right-0px">
              <label class="margin-bottom-0px font-family" *ngIf="c.ValueType!='Date'">{{c.Value}}</label>
              <label class="margin-bottom-0px font-family" *ngIf="c.ValueType=='Date'">{{c.Value | date:'MMM-dd-yyyy'}}</label>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>


</div>

